import {Header} from "../../common/header/header";

export const coopHeader = Header({
    icon: require("../../../../mailing-icons/listtype-condo.png"),
    title: "Create Co-op/Condo Address List",
    subTitle: "Build a list comprised of multi-family buildings and units on a particular street.",
});
